import moment from "moment";
import env from "../../utils/env";
import XLSX from "xlsx";

class UsersController {
  constructor(UsersService, FilterService, AuthService, $scope) {
    "ngInject"

    this.usersService = UsersService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
    this.imageBaseUrl = env.getStorageUrl() + "images/";
  }

  getGridOptions() {

    return {
      // selectable: "multiple cell",
      // allowCopy: true,
      dataSource: this.usersService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        {
          field: "fullName", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "12rem",
          template: (dataItem) => `<a class="cell" href="/users/${dataItem.userId}"><div class="image-container"><img src="${dataItem.imageUrl ? this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png"}"></img></div><span>${dataItem.fullName}</span></a>`,
        },
        { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" },
        { field: "userId", title: "User Id", filterable: false, width: "6rem", template: (dataItem) => `<a href="/users/${dataItem.userId}">${dataItem.userId}</a>` },        // { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" },
        { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" },
        {
          field: "email", title: "Email", filterable: false, width: "15rem",
          template: `<a href="mailto:#= email #">#= email #</a>`
        },
        { field: "creationDate", title: "Signup Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "8rem" },
        { field: "phoneNumber", title: "Phone Number", filterable: false, width: "10rem" },
        { field: "suburb", title: "Suburb", filterable: false, width: "8rem" },
        // { field: "state", title: "State/Region", filterable: false, width: "8rem" },
        { field: "country", title: "Country", filterable: false, width: "6rem" },
      ]
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  exportToExcel() {
    const ds = this.gridOptions.dataSource;
    const currentFilters = ds.filter() || {};
    const filters = (currentFilters.filters) || [];
    const total = ds.total();
 
    const payload = JSON.stringify({
      filters,
      page: 1,
      pageSize: total || 100000,
      skip: 0,
      take: total || 100000,
    });
 
    const token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;
 
    fetch(env.getApiUrl("entities/search"), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": token },
      body: payload,
    })
      .then(r => r.json())
      .then(result => {
        const rows = (result.data || []).map(u => ({
          Name: u.fullName,
          "Account Type": u.entityTypeName,
          "Account Status": u.accountStatusName,
          Email: u.email,
          "Phone Number": u.phoneNumber || '',
          "Signup Date": u.creationDate ? new Date(u.creationDate).toLocaleDateString('en-GB') : '',
          Suburb: u.suburb,
          Country: u.country,
        }));
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Users");
        const fileName = `users_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
        XLSX.writeFile(wb, fileName);
      });
  }

  dataSourceFetchSuccessCallback(e) {
    this.usersMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

}

export default UsersController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/users/users.controller.js
 **/